import { ICareRecommendationApis } from "./ICareRecommendationApis"
import ApiUtils from "../ApiUtils"
import { IDiagnosisRecommendation } from "../../interfaces/api/careRecommendation/IDiagnosisRecommendation"

const CareRecommendationApiUrls = {
	searchRecommendation: (recommendationType: string) => `${recommendationType}/search`,
}

export const RecommendationTypes = {
	diagnosis: "diagnosis-recommendation",
	labTest: "lab-test-recommendation",
	medicine: "medicine-recommendation",
}
export default class CareRecommendationApis implements ICareRecommendationApis {
	getServiceUrl = (url: string) => `/care-recommendation-service/${url}`
	searchRecommendations = (payload: any, recommendationType: string): Promise<any[]> => {
		return ApiUtils.post(this.getServiceUrl(CareRecommendationApiUrls.searchRecommendation(recommendationType)), payload)
	}
}
